import type { CookieConsentConfig } from "vanilla-cookieconsent";

export const cookieConsentConfig: CookieConsentConfig = {
    guiOptions: {
        consentModal: {
            layout: "box inline",
            position: "bottom",
            equalWeightButtons: true,
            flipButtons: true,
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false,
        },
    },

    categories: {
        necessary: {
            readOnly: true,
            enabled: true,
        },
        analytics: {
            enabled: false,
            readOnly: false,
        },
        marketing: {
            enabled: false,
            readOnly: false,
        },
    },

    language: {
        default: "fr",
        autoDetect: "browser",
        translations: {
            fr: {
                consentModal: {
                    description:
                        "En utilisant ce site web, vous acceptez l'utilisation des cookies sur ce site. Nous utilisons des cookies pour vous offrir une expérience optimale et pour assurer le bon fonctionnement de notre site web.",
                    acceptAllBtn: "J'accepte",
                    acceptNecessaryBtn: "Non merci",
                    showPreferencesBtn: "Gérer les cookies",
                },
                preferencesModal: {
                    title: "Gérer les cookies",
                    acceptAllBtn: "Tout accepter",
                    acceptNecessaryBtn: "Tout refuser",
                    savePreferencesBtn: "Enregistrer les préférences",
                    closeIconLabel: "Fermer",
                    serviceCounterLabel: "Service|Services",
                    sections: [
                        {
                            title: 'Nécessaires <span class="pm__badge">Toujours activés</span>',
                            description:
                                "Nécessaires pour activer les fonctionnalités de base du site et pour mémoriser les préférences et les choix de l'utilisateur, tels que la langue préférée et les paramètres personnalisés.",
                            linkedCategory: "necessary",
                        },
                        {
                            title: "Performances et analyses",
                            description:
                                "Ces cookies fournissent des indicateurs quantitatifs sur les visiteurs des sites web ; l'utilisation de ces cookies nous permet de compter les visites et les sources de trafic afin d'améliorer les performances de notre site.",
                            linkedCategory: "analytics",
                            cookieTable: {
                                headers: {
                                    name: "Nom",
                                    domain: "Service",
                                    description: "Description",
                                    expiration: "Expiration",
                                },
                                body: [
                                    {
                                        name: "_ga",
                                        domain: "Google Analytics",
                                        description: "Cookie d'analyse",
                                        expiration: "2 ans",
                                    },
                                    {
                                        name: "_gid",
                                        domain: "Google Analytics",
                                        description: "Cookie d'analyse",
                                        expiration: "24 heures",
                                    },
                                ],
                            },
                        },
                        {
                            title: "Publicité",
                            description:
                                "Ces cookies sont utilisés par les agences de publicité pour afficher des annonces qui correspondent à vos centres d'intérêt.",
                            linkedCategory: "marketing",
                        },
                    ],
                },
            },
        },
    },
};
